import { API } from "aws-amplify";

export const getCallLargeContentDownloadUrl = async (callId, fieldType) => {
  try {
    const response = await API.get(
      "eventapi",
      `/getCallLargeContentDownloadUrl/${callId}/${fieldType}`,
      {}
    );
    
    return {
      success: true,
      url: response.url,
      urlExpiresAt: response.urlExpiresAt
    };
  } catch (error) {
    console.error(`Error getting download URL for ${fieldType}:`, error);
    return {
      success: false,
      error: error.message || `Failed to get download URL for ${fieldType}`
    };
  }
};

export const downloadS3Content = async (callId, fieldType) => {
  const result = await getCallLargeContentDownloadUrl(callId, fieldType);
  
  if (result.success && result.url) {
    // Open the download URL in a new tab
    window.open(result.url, '_blank');
    return result;
  } else {
    throw new Error(result.error || 'Failed to get download URL');
  }
};
